var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65085 2.05085C9.58305 2.05085 10.478 2.46102 11.0746 3.05763C11.7085 3.69153 12.0814 4.54915 12.0814 5.51864C12.0814 6.45085 11.7085 7.30847 11.0746 7.94237C10.478 8.57627 9.58305 8.94915 8.65085 8.94915C7.68136 8.94915 6.82373 8.57627 6.18983 7.94237C5.59322 7.30847 5.18305 6.45085 5.18305 5.51864C5.18305 4.54915 5.59322 3.69153 6.18983 3.05763H6.22712C6.86102 2.42373 7.71864 2.05085 8.65085 2.05085ZM8.65085 11C7.2339 11 5.81695 10.5525 4.36271 9.69492C2.98305 8.8 1.5661 7.5322 0.111864 5.81695C-0.0372881 5.63051 -0.0372881 5.36949 0.111864 5.18305C1.5661 3.4678 2.98305 2.2 4.36271 1.34237C5.81695 0.447458 7.2339 0 8.65085 0C10.0305 0 11.4847 0.447458 12.9017 1.34237C14.3186 2.2 15.7356 3.50508 17.1898 5.18305C17.339 5.36949 17.339 5.63051 17.1898 5.81695C15.7356 7.5322 14.3186 8.8 12.9017 9.69492C11.4847 10.5525 10.0305 11 8.65085 11ZM4.88475 8.87458C6.15254 9.65763 7.42034 10.0678 8.65085 10.0678C9.88136 10.0678 11.1119 9.65763 12.4169 8.87458C13.6475 8.09153 14.9153 6.97288 16.1831 5.51864C14.9153 4.02712 13.6475 2.90847 12.4169 2.16271C11.1119 1.34237 9.88136 0.969492 8.65085 0.969492C7.42034 0.969492 6.15254 1.34237 4.88475 2.16271C3.65424 2.90847 2.38644 4.02712 1.11864 5.51864C2.38644 6.97288 3.65424 8.09153 4.88475 8.87458Z",
    fill: "#EAEEF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassShowIcon);
export default __webpack_public_path__ + "static/media/pass_show_icon.c4df2d0887630e6afa362937eb2a0b9d.svg";
export { ForwardRef as ReactComponent };